import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { CadastroUsuario } from 'src/app/entity/CadastroUsuario';
import { UnidadeDTO } from 'src/app/entity/UnidadeDTO';
import { MANIFESTO_ENUM } from 'src/app/tools/Manifestos';
import { SolicitacoesInformacoesLgpdComponent } from 'src/app/view/manifestos/lgpd/solicitacoes-informacoes-lgpd/solicitacoes-informacoes-lgpd.component';
import { ProcessoComponent } from 'src/app/view/manifestos/reclamacao';
import { ReclamacaoService } from 'src/app/service/reclamacao/reclamacao.service';
import { FILE_UPLOADER } from 'src/app/componentes/file-uploader/file-uploader.component';

@Component({
  selector: 'classificacao',
  templateUrl: './classificacao.component.html',
  styleUrls: ['./classificacao.component.css']
})
export class ClassificacaoComponent implements OnInit {

  @Input() manifestoSelecionado;
  @Input() assuntoSelecionado;
  @Input() visualizacao: boolean;
  @Input() edicao: boolean;
  @Input() cartoriosFiltrados: any[];
  @Input() unidade1: UnidadeDTO;
  @Input() unidade2: UnidadeDTO;
  @Input() usuario: CadastroUsuario; // Externo ou Interno
  @Input() arquivosSalvos: any[];
  manifestoEnum: any;
  @ViewChild(ProcessoComponent, { static: false }) processo: ProcessoComponent;
  @ViewChild(FILE_UPLOADER, { static: false }) fileUploader;
  @ViewChild(SolicitacoesInformacoesLgpdComponent, { static: false }) solicitacoesLgpd: SolicitacoesInformacoesLgpdComponent;

  constructor(public reclamacaoService: ReclamacaoService) {

    this.manifestoEnum = MANIFESTO_ENUM;
  }

  ngOnInit() {
    //console.log(this.assuntoSelecionado);
   // console.log(this.manifestoSelecionado);

  }

  get arquivosAnexados(){
    return this.processo.fileUploaderProcesso;
  }

}
